import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function WLMHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-2237">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/17upqFLBpx5hi7zX6fZ55t/weight-loss-for-men.jpg)'
    }} data-id="element-2238" />
      <div className="absolute inset-0 bg-black/50" data-id="element-2239" />
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-2240">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-2241">
          <div className="mb-6" data-id="element-2242">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-2243">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-2244">
                Treatments
              </a>{' '}
              / Body
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-2245">
            Be CONFIDENT
          </span>

          <h1 className="text-[32px] sm:text-5xl lg:text-[60px] uppercase text-white tracking-tight mb-2 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-2246">
            WEIGHT LOSS FOR MEN
          </h1>

          <p className="font-serif italic text-white/80 text-xl lg:text-2xl mb-8 mt-3" data-id="element-2247">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-2248">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-2249">
              <em data-id="element-2250">
                "Guys, we know you want that hot bod you can show off in clothes
                and out,"
              </em>{' '}
              says Dr. Fiona.{' '}
              <em data-id="element-2251">
                "It's no fun spending hours in the gym and watching what you eat
                only to see minimal results. At Be CLINICAL, we're here to give
                you that extra boost to achieve your fitness goals and get the
                body you deserve. Let's turn those hard workouts into hard
                bodies!"
              </em>
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-2252">
              As men age, particularly after 40, testosterone levels naturally
              begin to decline. This hormonal change can make it harder to lose
              weight through diet and exercise alone.{' '}
              <em data-id="element-2253">
                "Our male patients tend to visit us when the strategies that
                once worked are no longer working. This can be extremely
                frustrating and starts to take a toll on their self confidence."
              </em>
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-2254">
              At Be CLINICAL, we want our men to enjoy the benefits of fat loss,
              not just "weight loss." This approach emphasizes losing fat while
              preserving and building muscle mass, resulting in a more toned and
              defined physique. Fat loss is not only about looking better but
              also about enhancing overall health and fitness.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-2255">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}